module.exports = __webpack_public_path__ + "static/media/serp_filled_mobile.cd970db7.png";